module.exports = require("@embedpdf/plugin-interaction-manager/react");